import React from 'react';

import ICO_CLOSE from 'assets/images/btn-close.svg';

// eslint-disable-next-line react/prefer-stateless-function
class PopupHeader extends React.Component {
  static defaultProps = {
    children: [],
    isModalAction: false,
    history: null,
  };

  render() {
    const { onClose, style, children } = this.props;
    return (
      <div data-bem="PopupHeader" className="modal-header-marketing" style={style}>
        <div className="close" role="button" tabIndex={0} onClick={onClose}>
          <img src={ICO_CLOSE} alt="" />
        </div>
        {children}
      </div>
    );
  }
}

export default PopupHeader;
